module.exports = __webpack_public_path__ + "img/img_11.177a3d9c.jpg";